export function shouldRenderComponent(
  validations: boolean[],
  component: () => JSX.Element
) {
  const shouldRender = validations.every((validation) => validation);

  if (shouldRender) {
    return component();
  }

  return null;
}
